var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.id
    ? _c("div", { staticClass: "squadra-crediti", class: _vm.sizeClass }, [
        _vm.pic
          ? _c("img", { staticClass: "picture", attrs: { src: _vm.pic } })
          : _vm._e(),
        _vm._v(" "),
        !_vm.hideName && _vm.name
          ? _c("div", { staticClass: "nome-squadra" }, [
              _vm._v(_vm._s(_vm.name)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showCrediti && _vm.creditiToShow !== null
          ? _c("span", { staticClass: "crediti" }, [
              _vm._v(_vm._s(_vm.creditiToShow)),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }